const DashboardProgramSkeleton = () => {
    return <div className='h-[370px] w-full animate-pulse rounded-2xl border border-gray-200 bg-gray-100' />;
};

export default DashboardProgramSkeleton;

